import { GridColDef, GridRowIdGetter, GridRowParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { DataGridWrapper, StyledDataGrid, TableContainer } from './Table.styled';

export interface TableProps<TRow extends GridValidRowModel> {
  rows: TRow[];
  columns: GridColDef<TRow>[];
  onRowClick?: (row: TRow) => void;
  getRowId?: GridRowIdGetter<TRow>;
  noRowsLabel?: string;
  disableColumnMenu?: boolean;
  height?: number;
}

const HEADER_HEIGHT = 56;
const ROW_HEIGHT = 52;
const FOOTER_HEIGHT = 52;

export function Table<TRow extends GridValidRowModel>({
  rows,
  columns,
  onRowClick,
  getRowId,
  noRowsLabel = 'No Results Found.',
  disableColumnMenu = true,
  height,
}: TableProps<TRow>) {
  const gridHeight = height ?? HEADER_HEIGHT + rows.length * ROW_HEIGHT + FOOTER_HEIGHT;

  return (
    <TableContainer>
      <DataGridWrapper gridHeight={gridHeight}>
        <StyledDataGrid
          className={onRowClick ? 'row-clickable' : undefined}
          rows={rows}
          columns={columns}
          getRowId={getRowId}
          disableColumnMenu={disableColumnMenu}
          density="standard"
          onRowClick={(params: GridRowParams<TRow>) => onRowClick?.(params.row)}
          localeText={{
            noRowsLabel,
          }}
        />
      </DataGridWrapper>
    </TableContainer>
  );
}

export default Table;
